import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  InputDescription,
  InputFile,
  InputText,
  Modal,
  Tabs,
  TextAlert,
} from '../../../uiComponents/common';
import { removeObjectsWithEmptyFields } from '../../../helpers/forms';
import useLanguageSwitcher from '../../../hooks/useLanguageSwitcher';

const EditGalleryForm = ({ images, setImages, open, setOpen, editForm, defaultLanguage }) => {
  const validateFields = {
    nameImage: {
      rule: (values) => {
        if (!values.nameImage && !values.descriptionImage) {
          return true;
        } else if (values.nameImage && values.nameImage.trim() !== '') {
          return true;
        } else {
          return false;
        }
      },
      errorMsg: 'El campo "Título" es obligatorio y debe tener un mínimo de 3 caracteres.',
    },
    descriptionImage: {
      rule: (values) => {
        if (!values.nameImage && !values.descriptionImage) {
          return true;
        } else if (values.descriptionImage && values.descriptionImage.trim() !== '') {
          return true;
        } else {
          return false;
        }
      },
      errorMsg: 'El campo "Descripción" es obligatorio y debe tener un mínimo de 3 caracteres.',
    },
  };

  const methods = useForm();

  const { languages, lngErrors, currentLng, changeLanguage, setLanguages } = useLanguageSwitcher(
    validateFields,
    methods,
  );

  const onSubmit = (data) => {
    const updatedImages = images.map((image, idx) => {
      if (editForm.id === idx) {
        let langShowImage = languages.map((lng, i) => {
          return {
            id: image?.langShowImage[i]?.id ? image?.langShowImage[i]?.id : 0,
            showImageId: image?.langShowImage[i]?.showImageId
              ? image?.langShowImage[i]?.showImageId
              : 0,
            language: lng.shortForm,
            title: data[`nameImage_${lng.shortForm}`],
            description: data[`descriptionImage_${lng.shortForm}`],
          };
        });

        const handleLangShowsEmptys = removeObjectsWithEmptyFields(langShowImage, [
          'title',
          'description',
        ]);

        return {
          ...image,
          imageUrl: data.imageModal.base64,
          langShowImage: handleLangShowsEmptys,
        };
      }
      return image;
    });
    setImages(updatedImages);
    setOpen(false);
    methods.reset();
  };

  useEffect(() => {
    if (editForm) {
      const newLangs = languages.map((lang) => {
        let lng = editForm.data?.langShowImage[0]?.language
          ? editForm.data?.langShowImage[0]?.language
          : currentLng;
        return { ...lang, isActive: lang?.shortForm === lng };
      });

      setLanguages(newLangs);

      let formattedData = {
        imageModal: {
          base64: editForm?.data?.imageUrl ?? '',
          name: editForm.data?.langShowImage[0]?.title ?? '',
        },
      };

      editForm.data?.langShowImage.forEach((langShow) => {
        const lang = langShow.language;
        formattedData[`nameImage_${lang}`] = langShow.title;
        formattedData[`descriptionImage_${lang}`] = langShow.description;
      });
      methods.reset(formattedData);
    } else {
      methods.reset();
    }
  }, [editForm]);

  return (
    <FormProvider {...methods}>
      <form key={3}>
        <Modal
          textCancel={'Cancelar'}
          textSubmit={'Agregar'}
          idModal={'imageUploaderEdited'}
          title={'Agregar Imagen'}
          btnType='submit'
          onClose={() => {
            setOpen(false);
            methods.reset();
          }}
          open={open}
          handleSubmit={methods.handleSubmit(onSubmit)}
        >
          <InputFile
            id={'imageModal'}
            name={'imageModal'}
            className='col'
            placeholder={'Sube la imagen'}
            label={''}
          />
          <div className='my-2'>
            <Tabs onClick={(l) => changeLanguage(l)} options={languages} />
            {Object.keys(lngErrors).length !== 0 && (
              <div className='px-2'>
                <TextAlert text={lngErrors.name} type={'danger'} />
              </div>
            )}
          </div>
          <InputText
            name={'nameImage_' + currentLng}
            label={'Nombre de imagen'}
            className={'col'}
            placeholder={'Ingresa nombre de imagen'}
            icon={<i className='fas fa-theater-masks'></i>}
          />
          <InputDescription
            className='col'
            name={'descriptionImage_' + currentLng}
            label={'Descripción de imagen'}
            placeholder={'Ingresa una descripción corta'}
            icon={<i className='fas fa-edit'></i>}
          />
        </Modal>
      </form>
    </FormProvider>
  );
};

export default EditGalleryForm;
